import { render, staticRenderFns } from "./WfDevPublishMsgList.vue?vue&type=template&id=117bb616&scoped=true&"
import script from "./WfDevPublishMsgList.vue?vue&type=script&lang=js&"
export * from "./WfDevPublishMsgList.vue?vue&type=script&lang=js&"
import style0 from "./WfDevPublishMsgList.vue?vue&type=style&index=0&id=117bb616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bb616",
  null
  
)

export default component.exports